module.exports = __webpack_public_path__ + "static/media/ArpitBindal.5dd812ed.jpeg";